<dbx-entry-skeleton>
  <div class="form-container">
    <div class="title">{{ 'login.title' | translate }}</div>
    <form class="form" [formGroup]="verify2FA() ? verifyCodeForm : loginForm" (ngSubmit)="submit()">
      @if (verify2FA()) {
        @if (qrCodeUrl()) {
          <div class="instruction">{{ 'login.qrCodeInstruction' | translate }}</div>
          <div class="qr-code-container">
            <div class="qr-code" [style.background-image]="'url(\'' + qrCodeUrl() + '\')'"></div>
          </div>
          @if (qrCodeSecret()) {
            <div class="qr-code-secret">
              <div>{{ 'login.qrCodeSecretLabel' | translate }}</div>
              <div
                ><strong>{{ qrCodeSecret() }}</strong></div
              >
            </div>
          }
        } @else {
          <div class="instruction">{{ 'login.verifyCodeInstruction' | translate }}</div>
        }

        <div class="form-field">
          <mat-form-field class="field" floatLabel="always">
            <mat-label>{{ 'login.code' | translate }}</mat-label>
            <input
              id="code"
              type="text"
              name="code"
              formControlName="code"
              required
              matInput
              [errorStateMatcher]="errorStateMatcher"
              maxlength="6"
              dbxFocus
            />
            @if (submitted() && code?.invalid) {
              <mat-error>
                @if (code?.hasError('required')) {
                  {{ 'login.errors.codeRequired' | translate }}
                } @else if (code?.hasError('minlength') || code?.hasError('maxlength')) {
                  {{ 'login.errors.codeLength' | translate }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      } @else {
        <div class="form-field">
          <mat-form-field class="field" floatLabel="always">
            <mat-label>{{ 'login.email' | translate }}</mat-label>
            <input
              id="username"
              type="email"
              name="username"
              data-cy="username-input"
              formControlName="username"
              placeholder="email@example.com"
              required
              [readonly]="!singleSignOn() || ssoLogin()"
              matInput
              [errorStateMatcher]="errorStateMatcher"
              dbxFocus
            />
            @if (!singleSignOn() || ssoLogin()) {
              <mat-icon matSuffix (click)="loginBack()">edit</mat-icon>
            }
            @if (submitted() && username?.invalid) {
              <mat-error>
                @if (username?.hasError('required')) {
                  {{ 'login.errors.emailRequired' | translate }}
                } @else if (username?.hasError('email')) {
                  {{ 'login.errors.invalidEmail' | translate }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>

        @if (!singleSignOn()) {
          <div class="form-field">
            <mat-form-field class="field" floatLabel="always">
              <mat-label>{{ 'login.password' | translate }}</mat-label>
              <input
                id="password"
                data-cy="password-input"
                [type]="showPassword() ? 'text' : 'password'"
                name="password"
                formControlName="password"
                [placeholder]="'login.password' | translate"
                required
                matInput
                [errorStateMatcher]="errorStateMatcher"
                dbxFocus
              />
              <mat-icon matSuffix data-cy="password-visibility-toggle" (click)="togglePassword()">
                {{ showPassword() ? 'visibility' : 'visibility_off' }}
              </mat-icon>
              @if (submitted() && password?.invalid) {
                <mat-error>
                  @if (password?.hasError('required')) {
                    {{ 'login.errors.passwordRequired' | translate }}
                  } @else if (password?.hasError('minlength')) {
                    {{ 'login.errors.passwordMinLength' | translate }}
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>

          @if (temporaryPasswordExpired()) {
            <dbx-result-banner type="error" [message]="'login.errors.temporaryPasswordExpired' | translate" />
          }

          <button
            mat-button
            class="full-width"
            type="button"
            data-cy="forgot-password"
            [routerLink]="['/' + Paths.FORGET_PASSWORD_PATH]"
            [queryParams]="{ email: loginForm.getRawValue().username }"
          >
            {{ 'login.forgotPassword' | translate }}
          </button>
        }
      }

      @if (ssoLogin()) {
        @if (!ssoUserNotExists()) {
          <button
            mat-flat-button
            class="full-width"
            [disabled]="loading()"
            type="button"
            data-cy="sso-login"
            (click)="executeSSOLogin()"
          >
            <span class="loading-button-container">
              <span [style.visibility]="loading() ? 'hidden' : 'visible'">
                {{ 'login.loginWithSSO' | translate }}
              </span>
              @if (loading()) {
                <mat-spinner class="white" diameter="20"></mat-spinner>
              }
            </span>
          </button>
        } @else {
          <dbx-result-banner type="error" [message]="'login.errors.ssoUserNotExists' | translate" />
        }
      } @else {
        <button mat-flat-button class="full-width" [disabled]="loading()" type="submit">
          <span class="loading-button-container">
            <span [style.visibility]="loading() ? 'hidden' : 'visible'">
              {{ (singleSignOn() ? 'login.submit' : verify2FA() ? 'login.verify' : 'login.signIn') | translate }}
            </span>
            @if (loading()) {
              <mat-spinner class="white" diameter="20"></mat-spinner>
            }
          </span>
        </button>
      }

      @if (verify2FA() || ssoLogin()) {
        <button mat-button class="full-width" type="button" (click)="loginBack()">
          {{ 'login.back' | translate }}
        </button>
      }
    </form>
  </div>
</dbx-entry-skeleton>
